import React from 'react'
import { ListMenu, ListMenuButton, Modal, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useRouteMatch } from 'react-router-dom'
import { AddIcon } from 'assets/icons'
import EventCreate from 'src/apps/Events/apps/Create'
import InitiativeCreate from 'src/apps/Initiative/apps/Create'
import ModalRoute from 'src/components/utils/ModalRoute'
import Popover from 'src/components/utils/Popover'
import { useOrganization } from 'src/graphql/hooks'

const InitiativeCreateControl = ({ initiativeTypes }) => {
   const match = useRouteMatch()
   const { organization } = useOrganization()

   // TODO: This is a temporary means until we revise permissions
   // and specifically scope initiative creation permission
   // See PR #720
   if (!organization.currentUserCanEdit) {
      return null
   }

   return (
      <>
         <View display="flex">
            <Popover.Provider>
               <Popover.Anchor>
                  <View
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     height="30px"
                     borderRadius="4px"
                     backgroundColor="#000"
                     marginLeft="5px"
                     padding="0px 15px">
                     <AddIcon
                        color="#fff"
                        width="12px"
                        height="12px"
                        strokeWidth="3px"
                     />
                     <View position="relative" top="-1px" marginLeft="5px">
                        <Text size="1.5" color="#fff">
                           New
                        </Text>
                     </View>
                  </View>
               </Popover.Anchor>
               <Popover.View
                  anchorOriginHorizontal="right"
                  anchorOriginVertical="top"
                  backgroundColor="#fff"
                  borderRadius="3px"
                  margin="10px 0px"
                  width="180px">
                  <View
                     float="left"
                     width="100%"
                     borderRadius="3px"
                     boxShadow="3px 3px 12px rgba(0,0,0,0.2)"
                     backgroundColor="#fff">
                     <ListMenu buttonSize="md" buttonTextColor="#333">
                        {initiativeTypes.map(type => (
                           <ListMenuButton
                              key={type.id}
                              name={`New ${type.nameSingular}`}
                              linkTo={`${match.url}/create/${type.id}`}
                           />
                        ))}
                     </ListMenu>
                  </View>
               </Popover.View>
            </Popover.Provider>
         </View>
         <ModalRoute path={`${match.path}/create/:initiativeTypeId`}>
            {({ match: modalRouteMatch, open, onCloseComplete, onCloseTrigger }) => {
               const initiativeType = organization.initiativeTypes
                  .find(type => type.id === modalRouteMatch.params.initiativeTypeId)

               return (
                  <Modal
                     borderRadius="3px"
                     width="300px"
                     onCloseTrigger={onCloseTrigger}
                     onCloseComplete={onCloseComplete}
                     open={open}>
                     {initiativeType.class === 'event' && (
                        <EventCreate
                           initiativeTypeId={modalRouteMatch.params.initiativeTypeId}
                           onCancelButtonClick={onCloseTrigger}
                           onCloseTrigger={onCloseTrigger}
                           onCreate={onCloseTrigger}
                        />
                     )}
                     {initiativeType.class !== 'event' && (
                        <InitiativeCreate
                           initiativeTypeId={initiativeType.id}
                           onCancelButtonClick={onCloseTrigger}
                           onCloseTrigger={onCloseTrigger}
                           onCreate={onCloseTrigger}
                        />
                     )}
                  </Modal>
               )
            }}
         </ModalRoute>
      </>
   )
}

InitiativeCreateControl.propTypes = {
   initiativeTypes: PropTypes.array.isRequired
}

export default InitiativeCreateControl
